module.exports = __webpack_public_path__ + "img/PL00270.df9c76ba.svg";